module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vfcleg7-3381f71f9ca63117fcc233bb525fb04f.jpg";